module.exports = __webpack_public_path__ + "static/media/full screen_hover_toggle.44d8ff0d.svg";